import React, { useEffect, useState } from 'react';
import useAolSaveHandler from '../../../../app/useAolSaveHandler';
import { NoonReportSectionEnum, NoonReportTypeEnum } from '../../../../types/ViewModel/AolEnums';
import { AolDataItem } from '../../../../types/ViewModel/AolItem';
import { Vessel } from '../../../../types/ViewModel/Vessel/Vessel';
import { ErrorText } from '../../../shared/error-text/ErrorText.style';
import { SectionInnerWrapper, SubSectionHeader } from '../../aol-container/AolContainer.style';
import OdfjellInputComponent, { InputChangeData } from '../../../common/odfjell-input-component/OdfjellInputComponent';
import { EnginesDataVM } from '../EnginesSection';
import { EngineListWrapper } from '../EnginesSection.style';
import { hasInvalidFields } from 'src/utils/aolFieldsHelper';

type Props = {
    enginesDataVM: EnginesDataVM;
    onChange: () => void;
    vessel: Vessel | null;
    aolDataItem: AolDataItem;
    hasEmptyValues;
    isReadOnly: boolean;
};

const PumpsAndFansSectionComponent: React.FC<Props> = ({ enginesDataVM, onChange, aolDataItem, hasEmptyValues, isReadOnly }) => {
    const [hasEmptyValuesLocal, setHasEmptyValuesLocal] = useState(false);
    const { saveAolEvent } = useAolSaveHandler();

    useEffect(() => {
        if (!aolDataItem) return;
        initDataAolDataItem();
    }, [aolDataItem]);

    useEffect(() => {
        if (
            saveAolEvent &&
            saveAolEvent.type === 'save_section' &&
            saveAolEvent.section === NoonReportSectionEnum.Engines &&
            aolDataItem &&
            saveAolEvent.aolDataItem.id === aolDataItem.id
        ) {
            checkOnSave();
        }
    }, [saveAolEvent]);

    const initDataAolDataItem = () => {
        setHasEmptyValuesLocal(false);
        hasEmptyValues.current = false;
    };

    const onInputChange = (changeObject: InputChangeData) => {
        const name = changeObject.event.target.name;
        const value = changeObject.event.target.type === 'checkbox' ? changeObject.event.target.checked : changeObject.event.target.value;

        if (name === 'pumpsAndFansNotSwitchedOffReason') {
            changeObject.dataObject[name] = value ?? undefined;
        } else if (changeObject.event.target.type === 'checkbox') {
            changeObject.dataObject[name] = value;
        } else {
            changeObject.dataObject[name] = value ? +value : undefined;
        }
        resetHasEmptyValues();
        hasInvalidFields(enginesDataVM, name, changeObject.isValid);
        onChange();
    };

    const resetHasEmptyValues = () => {
        if (hasEmptyValuesLocal) {
            setHasEmptyValuesLocal(false);
            hasEmptyValues.current = false;
        }
    };

    const checkOnSave = () => {
        const hasMissing =
            aolDataItem.reportType === NoonReportTypeEnum.Port &&
            !enginesDataVM.arePumpsAndFansSwitchedOff &&
            !enginesDataVM.pumpsAndFansNotSwitchedOffReason;

        if (hasMissing) {
            setHasEmptyValuesLocal(true);
            hasEmptyValues.current = true;
        }
    };
    return (
        <>
            {aolDataItem.reportType === NoonReportTypeEnum.Port && (
                <SectionInnerWrapper>
                    <SubSectionHeader>Pumps and fans</SubSectionHeader>
                    <EngineListWrapper>
                        <OdfjellInputComponent
                            isReadOnly={isReadOnly}
                            type={'checkbox'}
                            description={'Pumps and fans switched off'}
                            dataObject={enginesDataVM}
                            name={'arePumpsAndFansSwitchedOff'}
                            value={enginesDataVM.arePumpsAndFansSwitchedOff}
                            onChange={onInputChange}
                        />
                        {!enginesDataVM.arePumpsAndFansSwitchedOff && (
                            <OdfjellInputComponent
                                isReadOnly={isReadOnly}
                                type={'text'}
                                description={'If not switched off, specify the reason'}
                                dataObject={enginesDataVM}
                                name={'pumpsAndFansNotSwitchedOffReason'}
                                value={enginesDataVM.pumpsAndFansNotSwitchedOffReason}
                                onChange={onInputChange}
                            />
                        )}
                    </EngineListWrapper>
                </SectionInnerWrapper>
            )}
            {hasEmptyValuesLocal && <ErrorText>You must specify the reason before saving.</ErrorText>}
        </>
    );
};

export default PumpsAndFansSectionComponent;
